import { useMergedRefs } from '@sparemin/blockhead';
import cn from 'classnames';
import React from 'react';
import { useElementBreakpoint } from 'hooks/useElementBreakpoint';
import { Header, UnitsContainer, Widget, WidgetProps } from './components';
import Unit, { UnitProps } from './components/Unit/Unit';
import { UnitsContainerProps } from './components/UnitsContainer';
import { THREE_BY_ONE_HSCROLL_DEFAULT_BREAKPOINT_MAX } from './constants';
import styles from './ThreeByOneHScrollWidget.module.scss';

type PickedProps = Pick<
  WidgetProps,
  'defaultNumberOfUnits' | 'maxNumberOfUnits'
> &
  Pick<
    UnitProps,
    | 'controls'
    | 'controlsSize'
    | 'artworkAspectRatio'
    | 'artworkResizeStrategy'
    | 'podcastInfo'
  >;

export interface ThreeByOneHScrollWidgetProps extends PickedProps {
  unitSpacing?: UnitsContainerProps['gutter'];
  unitsContainerClassName?: string;
  fadeColor?: UnitsContainerProps['backgroundColor'];
}

const ThreeByOneHScrollWidget = React.forwardRef<
  HTMLElement,
  ThreeByOneHScrollWidgetProps
>(
  (
    {
      artworkAspectRatio,
      artworkResizeStrategy,
      controls,
      controlsSize,
      defaultNumberOfUnits,
      maxNumberOfUnits,
      unitSpacing,
      podcastInfo,
      unitsContainerClassName,
      fadeColor,
    },
    forwardedRef,
  ) => {
    const { matches: isMobile, ref: mobileRef } = useElementBreakpoint({
      max: THREE_BY_ONE_HSCROLL_DEFAULT_BREAKPOINT_MAX,
    });

    const ref = useMergedRefs([mobileRef, forwardedRef]);

    return (
      <Widget
        className={cn(styles.root, { [styles.root__mobile]: isMobile })}
        ref={ref}
        {...{ defaultNumberOfUnits, maxNumberOfUnits }}
      >
        <Header />
        <UnitsContainer
          isMobile={isMobile}
          gutter={unitSpacing}
          gridClassName={unitsContainerClassName}
          backgroundColor={fadeColor}
        >
          <Unit
            {...{
              artworkAspectRatio,
              artworkResizeStrategy,
              controls,
              controlsSize,
              podcastInfo,
            }}
          />
        </UnitsContainer>
      </Widget>
    );
  },
);

export default ThreeByOneHScrollWidget;
